import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import Header from '../../components/Header';
import AssetSelectionTab from './AssetSelectionTab';
import ExternalTab from './ExternalTab';
import FtTab from './FtTab';
import UnifiedTab from './UnifiedTab';

/**
 * Tab selection lives in the URL (?tab=unified|ft|external|assets) so links
 * are shareable — safe here because the route mounts FilterBar with
 * filterConfig=[] (no URL-sync writer competing, see react-frontend.md).
 * Slugs, not indices: links stay stable if tab order changes. ExternalTab
 * additionally owns ?subtab=. Unknown slug falls back to Unified.
 */
const TAB_SLUGS = ['unified', 'ft', 'external', 'assets'];

const SamSchedulingPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const pipeline = Math.max(0, TAB_SLUGS.indexOf(searchParams.get('tab') || 'unified'));

  return (
    <Box m="20px">
      <Header
        title="SAM Scheduling"
        subtitle="Unified VNR SAM Cockpit · FT SAM · External SAM · Asset Selection"
      />
      <Tabs
        value={pipeline}
        onChange={(_, v) => setSearchParams({ tab: TAB_SLUGS[v] })}
        sx={{ mb: 2, borderBottom: '1px solid #e0e0e0' }}
      >
        <Tab label="Unified" />
        <Tab label="FT SAM" />
        <Tab label="External SAM" />
        <Tab label="Asset Selection" />
      </Tabs>
      {pipeline === 0 && <UnifiedTab />}
      {pipeline === 1 && <FtTab />}
      {pipeline === 2 && <ExternalTab />}
      {pipeline === 3 && <AssetSelectionTab />}
    </Box>
  );
};

export default SamSchedulingPage;
